/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { DivBackgroundOpacity, ListLinkContainer } from "@utils/extra-style";

import "@utils/extra-style.scss";

const CompanyLink = (props) => {
  const { t, data } = props;


  return (
    <>
      {data.id !== "" && (
        <DivBackgroundOpacity opacity={data.status === 1 ? 1 : "0.2"}>
          <ListLinkContainer>
            <Link
              to={`/company/view/${data.id}/general-info`}
              className="listing__link-info"
            >
              {data.name}
            </Link>
          </ListLinkContainer>
        </DivBackgroundOpacity>
      )}

      {data.id === "" && (
        <DivBackgroundOpacity opacity={data.status === 1 ? 1 : "0.2"}>
          {t(data.name)}
        </DivBackgroundOpacity>
      )}
    </>
  );
};

CompanyLink.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyLink);
